<template>
  <div class="pt-3 px-3 pb-1">
           
      <p v-if="channels.length == 0" class="text-center">No channels</p>

        <span v-else >

       <!-- Desktop -->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3" width="45%">Name ({{channels.length}})</th>
                  <th class="first-right px-3" width="15%">Action</th>
                </tr>
              </thead>
              <tbody>
    <tr v-for="(channel, index) in channels" :key="index">
        <td class="pl-3"><a :href="`${channel.url}/about`" target="_blank">{{ truncate(channel.name) }}</a></td>
        <td class="pl-3">
          <a href="#/" title="Restore channel" @click="showModalRestoreChannel(channel)"><i class="fa-solid fa-rotate-left"></i></a>
          </td>
    </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Title • Channel</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(channel, index) in channels" :key="index">
  
        <td class="pl-2">
            <div><a :href="`${channel.url}/about`" target="_blank">{{ truncate(channel.name) }}</a></div>
            <div><a v-if="channel.email" href="#/" :title="channel.email"><i class="fa-solid fa-envelope"></i></a></div>
            <div><timeago
                  :datetime="channel.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(channel.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>
<restore-channel :channel="channelInfo"></restore-channel>
          </div>

</template>

<script>
import RestoreChannel from './RestoreChannel.vue';

export default {
  components: { RestoreChannel },
  props: ['search_term'],

  watch: {
    search_term: function (val) {
      this.getChannels();
    }
  },

  data() {
    return {
      channels: [],
      channelInfo: {},
      loading: false,
    };
  },

  created() {
    this.getChannels();

    Echo.private("leads")
    .listen("SkipChannel", (event) => {
      this.getChannels();
    });
  },

  methods: {

    showModalRestoreChannel(channel) {
      this.channelInfo = channel;
      this.$bvModal.show("bv-modal-restore-channel");
    },

    truncate(string) {
        const max = 45;
      if (string.length > max)
        return string.substring(0, max) + ' ...';
      else
        return string;
    },

    getChannels() {

      this.loading = true;

      axios
        .post('/channels/skipped', {
          search_term: this.search_term,
        })
        .then((response) => {
          this.channels = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

  },
};
</script> 

<style scoped>

</style>